import { useLogout } from "@refinedev/core";
import { useEffect } from "react";

import { ApiError } from "@/lib/api";

/**
 * Возврат на вход при истёкшей сессии.
 *
 * Казалось бы, это работа `authProvider.onError` — но 401 от `useCustom` туда
 * НЕ доходит: проверено вживую 01.09.26 (сессия погашена, «Пересчитать» —
 * экран остался на `/placement`). Поэтому правило применяется здесь явно.
 *
 * Без него истёкшая сессия оставляет сотрудника перед сообщением «войдите
 * заново» и без единого способа это сделать — тупик, который прежний экран
 * обходил специально.
 *
 * Куда уводить, решает по-прежнему `authProvider.logout`: здесь только повод,
 * адрес входа в одном месте.
 */
export function useSessionGuard(error: unknown): void {
  const { mutate: logout } = useLogout();

  useEffect(() => {
    if (error instanceof ApiError && error.status === 401) logout();
  }, [error, logout]);
}
